<template>
    <div class="step-test-phone col-12">
        <div class="form-group field required">
            <label :for="inputId">{{ inputLabel }}</label>
            <kv-phone-input
                :placeholder="inputPlaceholder"
                :default-country="placeCountry"
                v-model="testValue"
            />
        </div>

        <!-- Slot for extra content (e.g., template selection for WhatsApp Cloud) -->
        <slot name="extra" />

        <div class="action-buttons mt-4">
            <button class="btn btn-secondary" @click="$emit('back')">{{ t('settings-connections-steps-back') }}</button>
            <button class="btn btn-success" @click="sendTest" :disabled="!testValue || testing">
                <Icon icon-class="ui-send-01" size="4" />
                <span v-if="!testing">{{ t('settings-connections-steps-send_test') }}</span>
                <span v-if="testing">{{ t('settings-connections-steps-sending_test') }}</span>
            </button>
        </div>
    </div>
</template>

<script>
import phoneMixin from "../../../../mixins/phone-mixin";
import KvPhoneInput from "../../../../components/kv-phone-input/kv-phone-input.vue";

export default {
    name: 'StepTestPhone',
    mixins: [phoneMixin],
    components: { KvPhoneInput },
    props: {
        /**
         * Input label
         */
        inputLabel: {
            type: String,
            default: 'Digite um número de celular',
        },
        /**
         * Input placeholder
         */
        inputPlaceholder: {
            type: String,
            default: '(##) #####-####',
        },
        /**
         * Input id for label association
         */
        inputId: {
            type: String,
            default: 'test-phone',
        },
        /**
         * Whether test is in progress
         */
        testing: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            testValue: null,
        };
    },
    methods: {
        sendTest() {
            this.$emit('test', this.testValue);
        },
        reset() {
            this.testValue = null;
        },
    },
};
</script>

<style scoped lang="less">
.step-test-phone {
    .form-group {
        margin-top: 80px;
    }

    .action-buttons {
        display: flex;
        gap: 12px;
        justify-content: stretch;
        
        button {
            flex: 1;
            justify-content: center;
        }
    }
}
</style>

